// Mellifluence (Venus): vowels are worth more at the base.
import { ALIGNMENT_NUMBERS as N } from '../constants';
import { isVowel } from '../shared/letters';
import type { AlignmentDef } from '../types';

export const mellifluence: AlignmentDef = {
  id: 'mellifluence',
  planet: 'venus',
  name: 'Mellifluence',
  text: () => `Vowels have +${N.mellifluenceAdd} base value.`,
  baseAdd: (star) => (isVowel(star.node.letter) ? N.mellifluenceAdd : 0),
};
